module.exports = __webpack_public_path__ + "fonts/mc4-icons.woff";